import { TRootState } from "../@types";

export const selectModalKits = ( state: TRootState ) =>state.kits.kitsModalIsOpen

export const selectIsUpdateKit = ( state: TRootState ) =>state.kits.isUpdateKit

export const selectKitForUpdate = ( state: TRootState ) =>state.kits.kitsForUpdate

export const selectKitsRefreshTable =  ( state: TRootState ) =>state.kits.refreshTableKits

export const selectKitsProductsRefreshTable = ( state: TRootState ) =>state.kits.refreshTableKitsProducts
